import { Component, OnInit } from '@angular/core';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { IndexadorAtualizacaoGarantiaCreditoLivre } from 'src/app/model/indexador-atualizacao-garantia-credito-livre';
import { IndexadoresService } from '../indexadores.service';
import { ResultadoPaginado } from 'src/app/model/resultado';

@Component({
    selector: 'app-indexadores-pesquisa',
    templateUrl: './indexadores-pesquisa.component.html',
    styleUrls: ['./indexadores-pesquisa.component.scss'],
    standalone: false
})
export class IndexadoresPesquisaComponent implements OnInit {

  indexadores: IndexadorAtualizacaoGarantiaCreditoLivre[] = [];
  pesquisado: boolean = true;
  atributosPaginacao: EntityPagedResult<IndexadorAtualizacaoGarantiaCreditoLivre>;
  opcoesPaginacao: number[]

  constructor(private indexadoresService: IndexadoresService) { }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
    this.paginarIndexadores()
  }

    public mudancaPagina(novaPagina: EntityPagedResult<IndexadorAtualizacaoGarantiaCreditoLivre>){
      this.atributosPaginacao = novaPagina;
      this.paginarIndexadores();
    }

    paginarIndexadores() {
      this.pesquisado = false;
      this.indexadoresService.paginarIndexadores(
        this.atributosPaginacao.page, this.atributosPaginacao.pageSize
      ).subscribe((resultado: ResultadoPaginado<IndexadorAtualizacaoGarantiaCreditoLivre>) => {
        this.indexadores = resultado.resultados.sort((a, b) => a.nome.localeCompare(b.nome));
        this.pesquisado = true;
      })
    }


}
